import { Impression } from '@fiverr-private/bianka_js';
import { getContext } from '@fiverr-private/fiverr_context';
import { bianka } from '@fiverr-private/obs';
import { AdBlockedGig } from '@fiverr-private/bianka_js/protobuf/bianka/event/activity/v2/extension/ad_blocked_gig';

export const reportAdBlockerDetection = (sellerId?: number, gigId?: number, auctionId?: number) => {
    const { userId, pageCtxId } = getContext();

    bianka.reportActivity<Impression>({
        type: Impression,
        event: {
            type: 'ad_blocked_gig',
            user: {
                id: userId as number,
            },
            ...(sellerId && { seller: { id: sellerId } }),
            ...(gigId && { gig: { id: gigId } }),
            page: {
                name: 'pro_catalog',
                ctxId: pageCtxId,
            },
        },
        additionalData: {
            type: AdBlockedGig,
            message: {
                ...(auctionId && {
                    auction: {
                        id: auctionId,
                    },
                }),
            },
        },
    });
};
